import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { IncidentType } from "@/types/db/incidents";
import { incidentService } from "@/services/incidentService";

interface IncidentEditProviderProps extends Omit<EntityEditProviderProps<IncidentType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function IncidentEditProvider({ children, entityData, loading, onSaveSuccess }: IncidentEditProviderProps) {
  const handleSave = async (formData: Partial<IncidentType>): Promise<IncidentType> => {
    if (!entityData?.id) {
      throw new Error("No incident ID available");
    }

    // Strip out read-only fields
    const { id, created_at, tenant_id, ...cleanFormData } = formData;

    // Update the incident
    const updatedIncident = await incidentService.updateIncident(entityData.id, cleanFormData);

    // Fetch complete data to return
    const completeIncident = await incidentService.getIncidentById(entityData.id);
    if (!completeIncident) {
      throw new Error("Failed to fetch updated incident data");
    }

    return completeIncident;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Incident"
    >
      {children}
    </EntityEditProvider>
  );
}
